import React from 'react';

function ReputationNav({ tabs, activeTab, onTabChange, counts = {} }) {
    return (
        <nav className="reputation-tab-nav" role="tablist" aria-label="Reputation sections">
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;
                const count = counts[tab.id];

                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`reputation-tab-nav__item${isActive ? ' is-active' : ''}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        <i className={`bi ${tab.icon}`} aria-hidden="true"></i>
                        <span>{tab.label}</span>
                        {count != null && count > 0 ? (
                            <span className="reputation-tab-nav__count">{count}</span>
                        ) : null}
                    </button>
                );
            })}
        </nav>
    );
}

export default ReputationNav;
